import { exists } from "fs";


export const cart_report = (cart, headers, cart_title) => {

	var logoBase64 = "maxisu/logo.png"
	const now = new Date()
	// var dateNow = new Date().toJSON().slice(0,10).replace(/-/g,'/')

	const dateNow = ('0' + now.getDate()).slice(-2)
		+ '.' +
		('0' + (now.getMonth() + 1)).slice(-2)
		+ '.' +
		now.getFullYear()

		// + ' ' +('0' + (now.getHours() + 1)).slice(-2)
		//  + ':' + 
		// ('0' + (now.getMinutes() + 1)).slice(-2)
		//  + ':' + ('0' + (now.getSeconds() + 1)).slice(-2)



	var columns = []

	var titles = []
	var total_price_title = ""

	headers.forEach((element, index) => {

		if(element.value == "stage") {
			return;
		}

		if (element.value == "total_price")
			total_price_title = element.text
		titles.push(element.text)

		columns.push(
			{
				header: element.text,
				key: element.value
			}
		)
	});

	var items = []
	var total_price = 0.0
	var sub_total_price = 0.0

	cart.forEach((pump, index) => {
		sub_total_price = pump.total_price * pump.order_count
		total_price += sub_total_price
		var dataRow = []
		headers.forEach(title => {
			if (title.value.endsWith('price')) {
				if (title.value == 'total_price') { // total price item
					dataRow.push(
						{ text: sub_total_price.toLocaleString(), alignment: 'right' }
					)
				} else {
					dataRow.push(
						{ text: pump[title.value].toLocaleString(), alignment: 'right' }
					)
				}
			} 
			else if (title.value == 'pump_type'){
				dataRow.push(pump[title.value] +" / " +pump['stage'])
			} else if (title.value.endsWith('stage')){
			} else
				dataRow.push(pump[title.value])
		})
		items.push(dataRow)
	})


	const itemsTable = items.unshift(titles)

	var dd = {
		pageMargins: [20, 20, 20, 10],
		content: [
			// {
			// 	table: {
			// 		// widths: [170, 150],
			// 		body: [titles]
			// 	}
			// }

			{
				table: {
					widths: [170, '*', 150],

					body: [
						[{
							margin: 10,
							width: 150,
							image: logoBase64,
							border: [false, false, false, false]
						},
						{
							alignment: 'center',
							text: '', margin: 10,
							border: [false, false, false, false]
						},

						{
							text: dateNow, fontSize: '10', alignment: 'right', margin: [5, 10],

							border: [false, false, false, false]
						}
						],

					]
				},


			},

			{ text: cart_title, style: 'header', margin: [0, 20, 0, 10] },

			{
				style: "content",
				table: {
					// widths: [170, 150],
					body: items
				}
			},

			{
				text: total_price_title + ': ' + total_price.toLocaleString(), alignment: 'right', margin: [0, 10, 0, 0]
			},


			, {

			}
			,






		],
		styles: {
			content: {
				fontSize: 10,
			},
			header: {
				fontSize: 18,
				bold: true,
				margin: [0, 0, 0, 10]
			},
			subheader: {
				fontSize: 16,
				bold: true,
				margin: [0, 10, 0, 5]
			},
			tableExample: {
				margin: [0, 5, 0, 15]
			},
			tableHeader: {
				bold: true,
				fontSize: 13,
				color: 'black'
			}
		},
		defaultStyle: {
			// alignment: 'justify'
		}

	}

	return dd;
}